import React from 'react';

function MAdminYmdEvent({ startDate, endDate, startHandle, endHandle }) {
    return (
        <div className="display-flex flex-row font-s-13 wd-80pc just-cont-sb p-l-5 font-t-cont">

            {/* 시작일 */}
            <div className="wd-49pc">
                <input
                    type="date"
                    min="1930-01-01"
                    max="2099-12-31"
                    value={startDate}
                    onChange={startHandle}
                    style={{
                        width: "100%",
                        height: "45px",
                        padding: "10px 12px",
                        border: "none",
                        outline: "none",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                        fontSize: "14px",
                        backgroundColor: "#fff",
                        WebkitAppearance: "none",   // 아이콘 중복 제거 효과
                        appearance: "none"
                    }}
                />
            </div>

            {/* 종료일 */}
            <div className="wd-49pc">
                <input
                    type="date"
                    min="1930-01-01"
                    max="2099-12-31"
                    value={endDate}
                    onChange={endHandle}
                    style={{
                        width: "100%",
                        height: "45px",
                        padding: "10px 12px",
                        border: "none",
                        outline: "none",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                        fontSize: "14px",
                        backgroundColor: "#fff",
                        WebkitAppearance: "none",
                        appearance: "none"
                    }}
                />
            </div>

        </div>
    );
}

export default MAdminYmdEvent
